<div class="full-column">
	<div class="gcse-searchresults-only" id="search-results-ctr" [hidden]="!searchScriptLoaded"></div>
</div>
